import { AxiosRequestConfig } from 'axios'

import useAuth from 'hooks/use-auth'
import { useGremlinQuery } from 'hooks/use-gremlin-query'
import { Company } from 'types/api/rbac/company'
import { ms } from 'utils/millisecond'

const QUERY_KEY_BASE_COMPANY = 'COMPANY'

export const companyQueryKeys = {
  withoutTeams: [QUERY_KEY_BASE_COMPANY, 'skipTeams=true']
}

export function useGetCompanyWithoutTeams(
  axiosRequestOptions: AxiosRequestConfig = {}
) {
  const { companyId } = useAuth()

  // this is a stop-gap to help customers with large numbers of teams out
  // want to cache these queries for a couple of minutes to speed things up if a user is actively navigating around company settings
  // the drawback is that if there are changes made to the company they'll have to refresh the page to see them or wait 2 minutes
  // ideally, this caching would be enabled conditionally based on the initial response data sizes
  // but that complexity will require more testing than there is time for at the moment
  const staleTime = ms.minutes(5) // wait 5 minutes before re-running API query
  const cacheTime = ms.minutes(10) // keep last copy of data around for 10 minutes

  const requestState = useGremlinQuery<Company>(
    // `?skipTeams` returns the company data without the list of teams, so the orgs prop is an empty array.
    // This should speed up this call for companies with lots of teams.
    `/companies/${companyId}?skipTeams=true`,
    axiosRequestOptions,
    {
      placeholderData: {} as Company,
      staleTime,
      cacheTime,
      queryKey: companyQueryKeys.withoutTeams
    }
  )

  return requestState
}
